import { render, staticRenderFns } from "./menuManageButtonAdd.vue?vue&type=template&id=588a3ed2&scoped=true&"
import script from "./menuManageButtonAdd.vue?vue&type=script&lang=js&"
export * from "./menuManageButtonAdd.vue?vue&type=script&lang=js&"
import style0 from "./menuManageButtonAdd.vue?vue&type=style&index=0&id=588a3ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a3ed2",
  null
  
)

export default component.exports